import { useEffect } from 'react'

/**
 * Proper state management for nested dialogs.
 * Simplified, but inspired by material-ui's DialogManager class.
 */
class DialogManager {
  dialogs
  constructor() {
    this.dialogs = []
  }

  add(dialog) {
    this.dialogs.push(dialog)
  }

  remove(dialog) {
    this.dialogs = this.dialogs.filter(_dialog => _dialog !== dialog)
  }

  isTopDialog(dialog) {
    const topmostDialog = this.dialogs[this.dialogs.length - 1]
    return topmostDialog === dialog
  }
}

export const manager = new DialogManager()

export function useDialogManager(ref, isOpen) {
  useEffect(() => {
    if (isOpen) {
      manager.add(ref)
    }
    return () => {
      manager.remove(ref)
    }
  }, [isOpen, ref])
}
